import { motion } from "framer-motion";
import { Layout, Smartphone, Zap, Palette } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const items = [
  { icon: Layout, title: "Custom websites", text: "Designed from scratch around your business — no cookie-cutter templates.", span: "md:col-span-2 md:row-span-2", big: true },
  { icon: Smartphone, title: "Mobile first", text: "Looks sharp on every phone, tablet and desktop.", span: "" },
  { icon: Zap, title: "Fast & smooth", text: "Lightweight builds that load quickly and feel effortless.", span: "" },
  { icon: Palette, title: "Your brand, elevated", text: "Colours, type and details that match who you are.", span: "md:col-span-3" },
];

const Card = ({ icon: Icon, title, text, span, big, i }) => (
  <Reveal delay={i * 0.08} className={span}>
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 260, damping: 22 }}
      data-testid={`service-card-${i}`}
      className={`group relative flex h-full flex-col justify-between overflow-hidden rounded-3xl border border-white/10 bg-[#0A1128] p-7 transition-colors duration-500 hover:border-sky-400/30 ${big ? "min-h-[340px] md:min-h-[440px]" : "min-h-[210px]"}`}
    >
      {big && <img src="/workspace.jpg" alt="Designer workspace" className="absolute inset-0 h-full w-full object-cover opacity-30 transition-transform duration-[1.5s] group-hover:scale-105" />}
      {big && <div className="absolute inset-0 bg-gradient-to-t from-[#0A1128] via-[#0A1128]/70 to-transparent" />}
      <Icon className="relative h-7 w-7 text-sky-300" strokeWidth={1.5} />
      <div className="relative">
        <h3 className={`font-display font-medium tracking-tight text-white ${big ? "text-3xl sm:text-4xl" : "text-xl"}`}>{title}</h3>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-300 sm:text-base">{text}</p>
      </div>
    </motion.div>
  </Reveal>
);

export const Services = () => (
  <section id="services" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-40">
    <Reveal>
      <Eyebrow>01 — What I build</Eyebrow>
      <h2 className="max-w-3xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-white sm:text-6xl">
        Websites that look the part <span className="text-slate-400">and work flawlessly.</span>
      </h2>
    </Reveal>
    <div className="mt-16 grid grid-cols-1 gap-4 md:grid-cols-3 md:grid-rows-[auto_auto_auto]">
      {items.map((it, i) => <Card key={it.title} {...it} i={i} />)}
    </div>
  </section>
);
